// Caractères spéciaux de l'orthographe douala absents d'un clavier AZERTY français.
// Les caractères déjà accessibles sur ce clavier (é, è, à, ù directs ; â, ê, î, ô, û
// via la touche morte circonflexe) sont volontairement exclus de cette palette.
//
// Tons : aigu = haut, grave = bas, macron = moyen. Le macron souscrit (a̱/e̱/o̱, U+0331)
// marque une qualité vocalique distincte de ɛ/ɔ.
//
// Chaque raccourci reste ancré sur Ctrl+Alt (équivalent à AltGr sur les claviers
// européens) pour ne jamais entrer en conflit avec les raccourcis du navigateur ou
// du système — contrairement à Alt+Maj seul, qui est le raccourci historique de
// Windows pour changer de disposition clavier et n'atteindrait donc jamais la page.
// Seuls les tons aigu/grave (de loin les plus fréquents dans le dictionnaire) ont un
// raccourci clavier ; macron et macron souscrit restent accessibles par clic.

function normalize(list) {
  return list.map(c => ({ ...c, char: c.char.normalize('NFC') }));
}

export const DUALA_SPECIAL_CHARS = normalize([
  { char: 'á', name: 'a aigu', shortcut: 'Ctrl+Alt+A', tone: 'ton haut' },
  { char: 'ā', name: 'a macron', shortcut: null, tone: 'ton moyen' },
  { char: 'a̱', name: 'a macron souscrit', shortcut: null, tone: null },

  { char: 'ē', name: 'e macron', shortcut: null, tone: 'ton moyen' },
  { char: 'e̱', name: 'e macron souscrit', shortcut: null, tone: null },

  { char: 'í', name: 'i aigu', shortcut: 'Ctrl+Alt+I', tone: 'ton haut' },
  { char: 'ì', name: 'i grave', shortcut: 'Ctrl+Alt+Maj+I', tone: 'ton bas' },
  { char: 'ī', name: 'i macron', shortcut: null, tone: 'ton moyen' },

  { char: 'ó', name: 'o aigu', shortcut: 'Ctrl+Alt+O', tone: 'ton haut' },
  { char: 'ò', name: 'o grave', shortcut: 'Ctrl+Alt+Maj+O', tone: 'ton bas' },
  { char: 'ō', name: 'o macron', shortcut: null, tone: 'ton moyen' },
  { char: 'o̱', name: 'o macron souscrit', shortcut: null, tone: null },

  { char: 'ú', name: 'u aigu', shortcut: 'Ctrl+Alt+U', tone: 'ton haut' },
  { char: 'ū', name: 'u macron', shortcut: null, tone: 'ton moyen' },

  { char: 'ɛ', name: 'e ouvert', shortcut: 'Ctrl+Alt+3', tone: null },
  { char: 'ɛ́', name: 'e ouvert aigu', shortcut: 'Ctrl+Alt+Maj+3', tone: 'ton haut' },

  { char: 'ɔ', name: 'o ouvert', shortcut: 'Ctrl+Alt+9', tone: null },

  { char: 'ñ', name: 'n nasal', shortcut: 'Ctrl+Alt+N', tone: null },
  { char: 'ń', name: 'n nasal aigu', shortcut: 'Ctrl+Alt+Maj+N', tone: 'ton haut' },
]);

// Table de correspondance raccourci -> caractère, pour l'écouteur clavier de l'éditeur.
// Clé normalisée : combinaison de modifiers (ctrl/alt/shift) + touche physique.
export const SHORTCUT_MAP = (() => {
  const map = {};
  const keyFor = (mods, key) => `${mods.sort().join('+')}+${key.toUpperCase()}`;

  DUALA_SPECIAL_CHARS.forEach(({ char, shortcut }) => {
    if (!shortcut) return;
    const parts = shortcut.split('+');
    const key = parts[parts.length - 1];
    const mods = [];
    if (shortcut.includes('Ctrl')) mods.push('ctrl');
    if (shortcut.includes('Alt')) mods.push('alt');
    if (shortcut.includes('Maj')) mods.push('shift');
    const normalizedKey = /^[0-9]$/.test(key) ? key : key.toUpperCase();
    map[keyFor(mods, normalizedKey)] = char;
  });
  return map;
})();

export function shortcutKeyFromEvent(e) {
  const mods = [];
  if (e.ctrlKey) mods.push('ctrl');
  if (e.altKey) mods.push('alt');
  if (e.shiftKey) mods.push('shift');
  const key = e.key.length === 1 ? e.key.toUpperCase() : e.key;
  return `${mods.sort().join('+')}+${key}`;
}
